import { render } from "./BlogPageThree.vue?vue&type=template&id=3f04369a"
import script from "./BlogPageThree.vue?vue&type=script&lang=js"
export * from "./BlogPageThree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__